let state = {
    trainStart:false,
    trainResult:false
}
export default state;


// WEBPACK FOOTER //
// ./src/store/state.js